"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _UIRemoveBrandingBanner = _interopRequireDefault(require("ui-addon-upgrades/alert/UIRemoveBrandingBanner"));

var _UpgradeProperties = require("lead-flows-ui/constants/UpgradeProperties");

var MarketingStarterUpgradeBanner = function MarketingStarterUpgradeBanner(_ref) {
  var screen = _ref.screen;
  return _react.default.createElement(_UIRemoveBrandingBanner.default, {
    upgradeData: {
      app: _UpgradeProperties.LEAD_FLOWS_APP,
      screen: screen,
      upgradeProduct: _UpgradeProperties.MARKETING_STARTER_PRODUCT,
      uniqueId: 'remove-branding'
    },
    modalKey: "leadflows-remove-branding"
  });
};

MarketingStarterUpgradeBanner.propTypes = {
  screen: _react.default.PropTypes.string.isRequired
};
var _default = MarketingStarterUpgradeBanner;
exports.default = _default;
module.exports = exports.default;